import { WidgetLink, WidgetLinkHue, WidgetLinkingID } from '@benzinga/widget-linking';
import React from 'react';
import styled, { css, hueToColor } from '@benzinga/themetron';
import { MenuNodeDef } from '@benzinga/widget-tools';
import { LinkUp } from '@benzinga/themed-icons';

export const linkingContextOption = (links: WidgetLink[], onClick: (linkId: WidgetLinkingID) => void): MenuNodeDef => {
  const linkToNodes = links.map<MenuNodeDef>(link => {
    return {
      action: () => onClick(link.id),
      icon: <LinkSwatch tooltipColor={link.hue}></LinkSwatch>,
      key: link.id ?? '',
      name: link.title,
      type: 'Item',
    };
  });
  return {
    icon: (<StyledLinkUp />) as React.ReactElement,
    key: 'linking',
    name: 'Link To',
    nodes: linkToNodes,
    type: 'SubMenu',
  };
};

const LinkSwatch = styled.div<{ tooltipColor: WidgetLinkHue }>`
  background-color: ${props =>
    props.tooltipColor !== null
      ? css`color-mix(in srgb, ${hueToColor(props.tooltipColor)}, ${props.theme.colors.backgroundInactive} 50%)`
      : props.theme.colors.background};
  vertical-align: center;
  height: 12px;
  width: 12px;
`;

const StyledLinkUp = styled(LinkUp)`
  width: 12px;
  height: 12px;
`;
